module.exports = __webpack_public_path__ + "img/technologie_training_784x514.a3f5b7b9.jpg";